import React from 'react';

import MarkedAcitivityItem from '../MarkedAcitivityItem/MarkedAcitivityItem';
import MarkedAnchorItem from '../MarkedAnchorItem/MarkedAnchorItem';

const MarkedItem = (props) => {
  const {
    actionTypeLabel,
    // isDeleted,
    action,
    filename,
    onClickFile,
    linkType,
    linkSubject,
    activity,
  } = props;
  const subject = linkSubject || filename;

  // To Confirm w/ Martin : not defined ? Can't find the respective component to import for this
  //   if (isDeleted) {
  //     return (

  //       <DeletedMarkedItem action={action} subject={subject} actionTypeLabel={actionTypeLabel} />
  //     );
  //   }

  if (activity && activity.includes('miscellaneous')) {
    return (
      <MarkedAcitivityItem
        activity={activity}
        linkType={linkType}
        linkSubject={linkSubject}
        onClickFile={onClickFile}
      />
    );
  }

  return (
    <MarkedAnchorItem
      action={action}
      subject={subject}
      actionTypeLabel={actionTypeLabel}
      onClickFile={onClickFile}
    />
  );
};

export default MarkedItem;
